/** @format */
import { css } from 'styled-components';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum MediaQuery {
    SMALL_MOBILE = '(max-width: 419px)',
    MOBILE = '(max-width: 479px)',
    SMALL_TABLET = '(max-width: 719px)',
    LARGE_TABLET = '(max-width: 959px)',
    DESKTOP = '(min-width: 960px)',
    LARGE_DESKTOP = '(min-width: 1440px)',
}

/**
 * Media queries are based of a base of 16px as rem units aren't affected by changes in font-size in
 * the HTML (when used in media queries) since they’re based on the browser’s internal font-size property.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
export const smallMobile = (styles: any) => css`
    @media only screen and ${MediaQuery.SMALL_MOBILE} {
        ${styles}
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
export const mobile = (styles: any) => css`
    @media only screen and ${MediaQuery.MOBILE} {
        ${styles}
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
export const smallTablet = (styles: any) => css`
    @media only screen and ${MediaQuery.SMALL_TABLET} {
        ${styles}
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
export const largeTablet = (styles: any) => css`
    @media only screen and ${MediaQuery.LARGE_TABLET} {
        ${styles}
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
export const desktop = (styles: any) => css`
    @media only screen and ${MediaQuery.DESKTOP} {
        ${styles}
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
export const largeDesktop = (styles: any) => css`
    @media only screen and ${MediaQuery.LARGE_DESKTOP} {
        ${styles}
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
